import axios from "axios";

// Always call the backend same-origin via the "/api" path (proxied by the
// platform/Cloudflare worker on both the preview subdomain and any custom
// domain). Using the absolute REACT_APP_BACKEND_URL here would make the
// auth cookie a third-party cookie on a custom domain (cookie is scoped to
// the backend's own host) and browsers block it -> every authenticated
// admin call 401s on the live custom domain while preview (single origin)
// works fine.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
